/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';
import 'bootstrap-select';
import AOS from 'aos';
import 'ics';
import './disclaimer';
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';
import sheets_data from './sheets_data';

$.migrateMute = true;

$(document).ready(() => {
  AOS.init();
  sheets_data.init();

  // Adding Bootstrap Modal to WordPress Menu
  const $modalToggle = $('.modal-toggle').find('a');

  $modalToggle.on('click', () => {
    const $modal = $('.modal-toggle')
      .find('a')
      .attr('href');
    // Hide navbar on click
    $('#navbar').collapse('hide');
    $($modal).modal('show');
  });

  // Case Studies Slider
  const caseStudiesSlider = new Swiper('.case-studies-slider .swiper', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 2.2,
    spaceBetween: 30,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      540: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      1500: {
        slidesPerView: 2.2,
        spaceBetween: 30,
      },
    },
  });

  // Our Approach Slider
  const ourApproachSlider = new Swiper('.our-approach-slider .swiper', {
    // configure Swiper to use modules
    loop: true,
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    slidesPerView: 3.2,
    spaceBetween: 30,
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      540: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 4.5,
        spaceBetween: 30,
      },
    },
  });

  // Open the mega menu when About Us is clicked.
  $('.menu-item.mm-item-1951 span').on('click', e => {
    e.preventDefault();

    $('#megaMenu1').collapse('show');
  });

  // close the megamenu if escape is clicked
  $(document).on('keyup', e => {
    if (e.key === 'Escape') {
      $('#megaMenu1').collapse('hide');
    }
  });

  $(document).on('click', function(e) {
    if (e.target.id !== 'mc-EMAIL') {
      $('#megaMenu1').collapse('hide');
    }
  });

  // Add scroll class on scroll/load
  const $window = $(window);
  const $body = $('body');
  const $header = $('.header');
  if ($body.hasClass('home')) {
    $window.on('scroll load', function() {
      if ($window.scrollTop() > 50) {
        $header.removeClass('header-dark');
      } else {
        //remove the background property so it comes transparent again (defined in your css)
        $header.addClass('header-dark');
      }
    });
  }

  // Add open class if mega menu open
  $('.mega-menu').on('shown.bs.collapse', function() {
    $body.addClass('mm-open');

    if ($body.hasClass('home')) {
      $header.removeClass('header-dark');
    }
  });

  // Remove open class if mega menu open
  $('.mega-menu').on('hidden.bs.collapse', function() {
    $body.removeClass('mm-open');

    if ($body.hasClass('home')) {
      $header.addClass('header-dark');
    }
  });

  $('.wpcf7 .form-control')
    .focus(function() {
      $(this)
        .parent()
        .parent()
        .addClass('active');
    })
    .blur(function() {
      var cval = $(this).val();
      if (cval.length < 1) {
        $(this)
          .parent()
          .parent()
          .removeClass('active');
      }
    });

  $('.wpcf7-not-valid').on('click', e => {
    e.currentTarget.parentElement();
  });
  $('.wpcf7-form-control').on('click', e => {
    if ($('.wpcf7-form-control').hasClass('wpcf7-not-valid')) {
      e.currentTarget.offsetParent.nextSibling.style.color = '#C62828';
    }
  });

  // Add show class for Contact Form submission
  document.addEventListener('wpcf7mailsent', function(event) {
    $('.wpcf7-form-success').show();
    $('.wpcf7-form-main').hide();
  });

  // Add show class for Careers Form submission
  document.addEventListener('wpcf7mailsent', function(event) {
    $('.wpcf7-careers-form-success').show();
    $('.wpcf7-careers-form-main').hide();
  });

  $('.js-flex-item').on('click', e => {
    const element = $('.js-flex-item');
    for (let i = 0; i < element.length; i++) {
      // element[i].style.backgroundColor="unset";
    }
    // e.currentTarget.style.backgroundColor="#CDE4FA"
  });

  // Download calendar ICS file
  $('.add-to-calendar a').on('click', function(e) {
    e.preventDefault();

    const ics = require('ics');

    // Get text from calendar listing
    let title = $(this)
      .closest('tr')
      .find('.event-title')
      .text();
    let date = $(this)
      .closest('tr')
      .find('.event-date')
      .text();

    // Get date format and split to array
    let date_array = date.split('/');
    let date_day = date_array[0];
    let date_month = date_array[1];
    let date_year = date_array[2];

    // Grab calendar data
    const event = {
      start: [date_year, date_month, date_day, 0, 0],
      end: [date_year, date_month, date_day, 0, 0], //duration: { hours: 0, minutes: 0 },
      title: title,
      status: 'CONFIRMED',
    };

    // Build file with ICS calendar data
    ics.createEvent(event, (error, value) => {
      if (error) {
        alert('ICS file could not be downloaded.');
        console.log(error);
        return;
      }

      //console.log(value);

      // Download ICS file with calendar data
      window.open('data:text/calendar;charset=utf8,' + escape(value));
    });
  });

  // Enable bootstrap select for all selects
  $('select').selectpicker();
  $('.chart-from-sheets select').selectpicker('destroy');
});

$(() => {
  $('.faux-filters a').each(function() {
    if (
      window.location.href
        .replace(/page\/\d+\//, '')
        .endsWith($(this).attr('href'))
    ) {
      $(this).addClass('active');
    }
  });
});

// Add active class to first category item
const url = window.location.href;
    const urlSplit = url.split('/');
    if (!urlSplit[4]) {
      $('#nav-item-1 a').addClass('active');
    }

$(() => {
  /**
   * initMap
   *
   * Renders a Google Map onto the selected jQuery element
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @return  object The map instance.
   */
  function initMap($el) {
    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
      zoom: $el.data('zoom') || 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
    };
    var map = new google.maps.Map($el[0], mapArgs);

    // Add markers.
    map.markers = [];
    $markers.each(function() {
      initMarker($(this), map);
    });

    // Center map based on markers.
    centerMap(map);

    // Return map instance.
    return map;
  }

  /**
   * initMarker
   *
   * Creates a marker for the given jQuery element and map.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   jQuery $el The jQuery element.
   * @param   object The map instance.
   * @return  object The marker instance.
   */
  function initMarker($marker, map) {
    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
      position: latLng,
      map: map,
    });

    // Append to reference for later use.
    map.markers.push(marker);

    // If marker contains HTML, add it to an infoWindow.
    if ($marker.html()) {
      // Create info window.
      var infowindow = new google.maps.InfoWindow({
        content: $marker.html(),
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open(map, marker);
      });
    }
  }

  /**
   * centerMap
   *
   * Centers the map showing all markers in view.
   *
   * @date    22/10/19
   * @since   5.8.6
   *
   * @param   object The map instance.
   * @return  void
   */
  function centerMap(map) {
    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function(marker) {
      bounds.extend({
        lat: marker.position.lat(),
        lng: marker.position.lng(),
      });
    });

    // Case: Single marker.
    if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
    } else {
      map.fitBounds(bounds);
    }
  }

  // Render maps on page load.
  $(document).ready(function() {
    $('.acf-map').each(function() {
      var map = initMap($(this));
    });
  });
});

/**
 * Meet the team dropdowns
 */
$(() => {
  const SNAP_LG = 992;
  const SNAP_SM = 767;

  /**
   * Fixes the flex order so the people dropdown appears in the right place.
   */
  const fixFlexOrder = () => {
    let j = 0;
    $('.js-flex-reorder>.js-flex-panel').each((i, el) => {
      const $panel = $(el);
      const $dropdown = $(el).next();
      const windowWidth = Math.max(
        document.documentElement.clientWidth,
        window.innerWidth || 0
      );
      const divisor = windowWidth > SNAP_LG ? 3 : windowWidth < SNAP_SM ? 1 : 2;
      const rowOrder = Math.ceil((j + 1) / divisor);
      if ($panel.is(':visible')) {
        // Fix flex
        $panel.css('order', rowOrder).addClass('is-number-' + (j + 1));
        $dropdown.css('order', rowOrder + 1);
        j++;
      } else {
        // Reset everything else to zero
        $panel.css('order', 0);
        $dropdown.css('order', 0);
      }
    });
  };

  $('.people__nav li:first-child a[data-filter]').addClass('active');
  const teamFilterFirst = $('.people__nav li:first-child a[data-filter]').attr(
    'data-filter'
  );
  $('[data-teams]').hide();
  $(`[data-teams*="${teamFilterFirst}"]`).show();

  fixFlexOrder();

  $('a[data-filter]').on('click', function() {
    // Close any stray open person dropdowns
    $('section.people .collapse').collapse('hide');

    // Hide everything
    $('[data-teams]').hide();

    // Remove active class to link if it has one
    $('a[data-filter]').removeClass('active');

    // Add active class to link
    $(this).addClass('active');

    // Show according to filters
    const teamFilter = $(this).attr('data-filter');
    $(`[data-teams*="${teamFilter}"]`).show();

    // Re-apply flex order fix
    fixFlexOrder();
  });
});

// Toggle header-mobile class
$('.navbar-toggler, .modal-toggle a').click(function() {
  $('.header').toggleClass('header-mobile');
});

window.addEventListener('resize', function() {
  const width = window.innerWidth;

  if (width >= 992) {
    $('.header').removeClass('header-mobile');
    $('#navbar').removeClass('show');
    $('.navbar-toggler').attr('aria-expanded','false');
    $('body').removeClass('position-fixed');
  } else {
    $('.header').addClass('header-desktop');

    // Stop background content from scrolling when mobile menu is active
    $('#navbar').on('show.bs.collapse', function() {
      $('body').addClass('position-fixed');
    });
  }
})

$('#navbar').on('hide.bs.collapse', function() {
  $('body').removeClass('position-fixed');
});

// Funds Modal
$(window).load(function() {
  $('#fundsModal').modal('show');
});
